'use strict';

import { trailer } from './_trailer';

export const modal = (() => {

    /**
     * init
     */
    const init = () => {

        $(document).on('click', '.js-show-modal', event => {
            event.preventDefault();

            const $this = $(event.currentTarget);
            const id = $this.data('modal-id');
            const $modal = $('#' + id);

            if(id === 'detail') {
                $('.js-carousel-character').slick('goTo', $this.data('index'), true);
            }

            show($modal);
        });

        $(document).on('click', '.js-hide-modal', event => {
            const $this = $(event.currentTarget);
            const id = $this.data('modal-id');
            const $modal = $('#' + id);

            if(id === 'trailer'){
                trailer.stop();
            }

            hide($modal);
        });
    };

    /**
     * show
     */
    const show = ($modal, option) => {
        $modal.addClass('is-show');
        $modal.find('.modal__overlay').height($modal.find('.modal__body').height());
        $('body').addClass('is-show-modal');
    };

    /**
     * hide
     */
    const hide = $modal => {
        $modal.removeClass('is-show');
        $('body').removeClass('is-show-modal');
    };

    return {
        init: init
    };
})();
